import { useEffect, memo } from 'react'
import { HookResult } from '../hooks/hookTypes'
import { useLogout } from '../network/axiosInstance'

function Logout() {
    const result = useLogout()
    const { data, loading, success, error, errorData, execute } = result

    useEffect(() => {
        // Execute the request when the component mounts
        execute()
    }, [execute])

    useEffect(() => {
        // It's a good fucking bye time!
        if (success && data) {
            window.location.href = '/' // Redirect to the login page
        }
    }, [success, data])

    return (
        <div>
            {loading ? (
                <p>Logging out...</p>
            ) : error ? (
                <p>Error fetching data: {errorData}</p>
            ) : (
                <p>Logged out successfully!</p>
            )}
        </div>
    )
}

export default memo(Logout)
